<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="isDisabled" [multiple]="multiple"
           [placeholder]="'hx.enum-select.placeholder.choose' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op">{{('hx.enum.' + enumName + '.' + op) | transloco}}</ng-option>
</ng-select>
